import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router';
import { readStickyTab } from './tabConfig';

/**
 * Plan 94 Phase 1 - `/devices/:deviceId` with no tab redirects to the sticky tab
 * preference (default: overview). Device identity stays in the URL; only the tab
 * is remembered.
 *
 * The query string rides along so FS-542's carried list context survives the
 * redirect — a tab-less link out of the Devices page still lands in the walk.
 */
const WorkspaceIndexRedirect: React.FC = () => {
  const { deviceId } = useParams<{ deviceId: string }>();
  const { search } = useLocation();
  return <Navigate to={`/devices/${deviceId}/${readStickyTab()}${search}`} replace />;
};

export default WorkspaceIndexRedirect;
